export default {
  /**
   * Return store name
   *
   * @param {Object} store
   * @returns {String}
   */
  getStoreName (store) {
    return store ? `${store.name}, ${store.province}` : ''
  }
}
